import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        resource: {
            type: definePropType(Object),
            default: function() {}
        },
        loading: {
            type: definePropType(Boolean),
            default: false
        },
        iconStyle: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var addResource = function() {
            emit("addResource", props.resource);
        };
        return {
            addResource: addResource
        };
    }
});
